import TableZurueckgewiesenCodes from '../components/TableZurueckgewiesenCodes';

const Zuruechgewiesen = () => (
  <div>
    <TableZurueckgewiesenCodes />
  </div>
);

export default Zuruechgewiesen;
